export default __webpack_public_path__ + "static/media/ls.636e15ae.svg";